import './DictpickerModal.scss';
import { portalOverlayClassName } from '@srm/ui/lib/portalOverlay';
import { FC, useEffect, useState } from 'react';
import Button from '@srm/ui/button';
import Modal from '@srm/ui/modal';
import { IAddDictForm, IForms } from '@models/Forms/IForms';
import { DictionariesService } from '@services/DictionariesService';
import { sendModalMsg } from '@srm/ui/lib/modalMessages';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { IField, IFieldElem, IFormData } from '@models/IFormData';
import { convertListToMap, getFieldKeysByScheme } from '@utils/documentUtils';
import FormProviderControl from '@controls/FormProviderControl';
import HookFormProvider from '@srm/ui/controls/HookFormProvider';
import NestedFormBuilder from '@molecules/formbuilder/NestedFormBuilder/NestedFormBuilder';
import clsx from 'clsx';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';

export interface IDictAddFormModalProp {
    settings: IAddDictForm;
    onClose: () => void;
    onSubmit?: (data: IFormData) => Promise<void>;
}

const DictAddFormModal: FC<IDictAddFormModalProp> = (p: IDictAddFormModalProp) => {
    const [form, setForm] = useState<IForms>();
    const methods = useForm<IFormData>({
        mode: 'onBlur', // "onChange"
    });
    const [fieldsData, setFieldsData] = useState<Record<string, IFieldElem>>();
    const fieldsName: number[] = [];
    // Escape и клик по фону закрывают окно: заполненную запись без вопроса не теряем
    const hasUnsavedInput = useUnsavedFormInput(methods);
    const { isSubmitting } = methods.formState;
    const close = () => {
        if (!isSubmitting) p.onClose();
    };
    useEffect(() => {
        DictionariesService.fetchAddFormScheme(p.settings.customForm).then((response) => {
            const keys = getFieldKeysByScheme(response.data.form.view.rows.row, false, response.data.form.changeActions);
            const uniqueKeys = keys.filter((v, i, a) => v !== undefined && a.indexOf(v) === i);
            const formFields: IField[] = [];
            uniqueKeys.forEach((key) => {
                formFields.push({ name: key, value: null });
            });
            const data = { fields: formFields };

            methods.reset(data);
            setFieldsData(convertListToMap(data.fields, ''));
            setForm(response.data.form);
        });
    }, [p.settings.customForm]);

    const onSubmitHandler: SubmitHandler<IFormData> = async (data: IFormData) => {
        p.onSubmit && (await p.onSubmit(data));
    };

    const ModalFooter = ({ onClose }: { onClose: () => void }) => (
        <div className="dictModal_footer">
            <Button type="submit" form="add-dict-form" size="sm">
                Сохранить
            </Button>
            <Button onClick={onClose} variant="light" size="sm">
                Отменить
            </Button>
        </div>
    );

    return (
        <Modal
            size="xl"
            className={clsx('dictExternalSearchModal', portalOverlayClassName)}
            onClose={close}
            hasUnsavedInput={hasUnsavedInput}
            closeDisabled={isSubmitting}
            footer={<ModalFooter onClose={close} />}
        >
            <FormProviderControl
                id="add-dict-form"
                changeActions={form?.changeActions}
                formMethods={methods}
                className="doc-form"
                onSubmit={onSubmitHandler}
            >
                <HookFormProvider controller={Controller}>
                    <div className="dict-add-form__wrapper">
                        <div className="dict-add-form__content">
                            <NestedFormBuilder
                                fields={fieldsData!}
                                setError={(errors?: string[]) => {
                                    if (errors) {
                                        sendModalMsg({
                                            message: errors,
                                            type: 'error',
                                        });
                                    }
                                }}
                                rows={form?.view}
                                isEdit={false}
                                isNew={true}
                                formMethods={methods}
                                includedFields={fieldsName}
                                uniqueKey={'add-dict-form'}
                            />
                        </div>
                    </div>
                </HookFormProvider>
            </FormProviderControl>
        </Modal>
    );
};

export default DictAddFormModal;
